import { useState } from 'react'
import { supabase } from './supabase'

function Login({ onLogin }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isSignUp, setIsSignUp] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')
    setError('')

    if (isSignUp) {
      const { error } = await supabase.auth.signUp({ email, password })
      if (error) { setError(error.message) } else { setMessage('Check your email for a confirmation link.') }
    } else {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) { setError(error.message) } else { onLogin(data.user) }
    }
    setLoading(false)
  }

  return (
    <div style={st.page}>
      <style>{`
        @keyframes grid-scroll{0%{transform:translateY(0)}100%{transform:translateY(44px)}}
        @keyframes glow-pulse{0%,100%{opacity:.3}50%{opacity:.5}}
        *{margin:0;padding:0;box-sizing:border-box}
        input::placeholder{color:#475569}
      `}</style>

      <div style={st.gridBg}></div>
      <div style={st.glow}></div>

      <div style={st.container}>
        <div style={st.logoSection}>
          <div style={st.logoGroup}>
            <svg viewBox="0 0 36 36" width="36" height="36">
              <defs><linearGradient id="llg" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#1e3a5f"/><stop offset="100%" stopColor="#0f2440"/></linearGradient></defs>
              <rect x="0" y="0" width="36" height="36" rx="7" fill="url(#llg)"/>
              <polygon points="9,27 9,9 12.5,9 18,17 23.5,9 27,9 27,27 23.5,27 23.5,15 18,23 12.5,15 12.5,27" fill="white"/>
            </svg>
            <span style={st.logoText}>MRVN</span>
          </div>
          <p style={st.logoSub}>Structural Engineering Platform</p>
        </div>

        <div style={st.card}>
          <h2 style={st.cardTitle}>{isSignUp ? 'Create your account' : 'Welcome back'}</h2>
          <p style={st.cardSub}>{isSignUp ? 'Start your free account to access engineering design tools.' : 'Sign in to access your engineering design tools.'}</p>

          <form onSubmit={handleSubmit} style={st.form}>
            <div style={st.formGroup}>
              <label style={st.label}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required
                style={st.input} onFocus={e => e.target.style.borderColor = 'rgba(30,58,95,0.6)'} onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'} />
            </div>
            <div style={st.formGroup}>
              <label style={st.label}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder={isSignUp ? 'Create a password' : 'Enter your password'} required minLength={6}
                style={st.input} onFocus={e => e.target.style.borderColor = 'rgba(30,58,95,0.6)'} onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'} />
            </div>

            {error && <div style={st.errorMsg}>{error}</div>}
            {message && <div style={st.successMsg}>{message}</div>}

            <button type="submit" disabled={loading} style={st.submitBtn}>
              {loading ? 'Please wait...' : isSignUp ? 'Create Account' : 'Sign In'}
            </button>
          </form>

          <div style={st.switchRow}>
            <span style={st.switchText}>{isSignUp ? 'Already have an account?' : "Don't have an account?"}</span>
            <button onClick={() => { setIsSignUp(!isSignUp); setError(''); setMessage('') }} style={st.switchBtn}>
              {isSignUp ? 'Sign In' : 'Sign Up'}
            </button>
          </div>
        </div>

        <p style={st.footerText}>&copy; 2026 MRVN. All rights reserved.</p>
      </div>
    </div>
  )
}

const st = {
  page: { minHeight: '100vh', background: '#080c18', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif', position: 'relative', overflow: 'hidden', padding: '2rem' },
  gridBg: { position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(59,130,246,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(59,130,246,0.03) 1px,transparent 1px)', backgroundSize: '44px 44px', animation: 'grid-scroll 10s linear infinite' },
  glow: { position: 'absolute', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle,rgba(30,58,95,0.1) 0%,transparent 70%)', top: '20%', left: '50%', transform: 'translateX(-50%)', animation: 'glow-pulse 6s ease-in-out infinite' },
  container: { width: '100%', maxWidth: '400px', position: 'relative', zIndex: 2 },
  logoSection: { textAlign: 'center', marginBottom: '2rem' },
  logoGroup: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '0.5rem' },
  logoText: { fontWeight: 800, fontSize: '1.5rem', letterSpacing: '0.08em', color: '#f1f5f9' },
  logoSub: { fontSize: '0.85rem', color: '#64748b' },
  card: { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', padding: '2rem' },
  cardTitle: { fontSize: '1.25rem', fontWeight: 700, color: '#f1f5f9', marginBottom: '0.35rem' },
  cardSub: { fontSize: '0.9rem', color: '#64748b', marginBottom: '1.5rem' },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  formGroup: { display: 'flex', flexDirection: 'column', gap: '0.35rem' },
  label: { fontSize: '0.8rem', fontWeight: 600, color: '#94a3b8', letterSpacing: '0.02em' },
  input: { padding: '0.7rem 0.85rem', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px', fontSize: '0.95rem', color: '#e2e8f0', outline: 'none', transition: 'border-color 0.2s', fontFamily: 'inherit' },
  errorMsg: { fontSize: '0.85rem', color: '#ef4444', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.15)', padding: '0.6rem 0.85rem', borderRadius: '6px' },
  successMsg: { fontSize: '0.85rem', color: '#22c55e', background: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.15)', padding: '0.6rem 0.85rem', borderRadius: '6px' },
  submitBtn: { padding: '0.75rem', background: '#3b82f6', border: 'none', borderRadius: '6px', color: 'white', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 0 25px rgba(59,130,246,0.2)', marginTop: '0.5rem' },
  switchRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem', marginTop: '1.25rem', paddingTop: '1.25rem', borderTop: '1px solid rgba(255,255,255,0.06)' },
  switchText: { fontSize: '0.85rem', color: '#64748b' },
  switchBtn: { background: 'none', border: 'none', color: '#3b82f6', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'inherit' },
  footerText: { textAlign: 'center', marginTop: '2rem', fontSize: '0.8rem', color: '#334155' },
}

export default Login
